module.exports = __webpack_public_path__ + "static/media/vidami-logo-new-tif.70d707cf.png";